/* eslint-disable import/no-anonymous-default-export */
import { api } from "./apiServices";

export const loginUser = (user) => api().post("/auth/login",user).then(handleResponse);
export const checkLogin = (token) => api(token).get("/auth/checkLogin").then(handleResponse);
export const signUpUser = (user) => api().post("/auth/signup",user).then(handleResponse);

const handleResponse = (response) => {
  let data = response.data;
  if(response.data.code==6){
    localStorage.removeItem("token");
    window.location.href = "/login";
  }
  return data;
};
